<template>
    <div v-if="ad" class="home-content-ad" :style="wrapperStyle">
        <advertisement-placement placement="home_content" />
    </div>
</template>

<script>
import AdvertisementPlacement from "@/components/App/advertisement-placement.vue";

export default {
    name: "home-content-ad",
    components: { AdvertisementPlacement },
    computed: {
        ad() {
            return this.$store.state.advertisements.home_content || null;
        },
        wrapperStyle() {
            if (!this.ad) {
                return {};
            }

            return {
                aspectRatio: `${this.ad.width} / ${this.ad.height}`,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.home-content-ad {
    width: 100%;
    margin-bottom: 20px;
    border-radius: $radius;
    overflow: hidden;

    ::v-deep .advertisement-placement {
        width: 100% !important;
        height: 100% !important;
        max-width: none;

        a {
            display: block;
            width: 100%;
            height: 100%;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            display: block;
        }
    }
}
</style>
